import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "column-space id-column" }
const _hoisted_2 = { class: "ml-2" }
const _hoisted_3 = { class: "column-space" }
const _hoisted_4 = { class: "column-space" }
const _hoisted_5 = { class: "column-space" }
const _hoisted_6 = { class: "d-flex w-75" }
const _hoisted_7 = { class: "w-75 d-flex align-items-center" }
const _hoisted_8 = { class: "w-25 justify-content-between align-items-center" }
const _hoisted_9 = { class: "column-space" }
const _hoisted_10 = { class: "column-space" }
const _hoisted_11 = { class: "column-space" }
const _hoisted_12 = { class: "column-space" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { colspan: "9" }

import OpenNewWindowIcon from "@/components/AuditLog/OpenNewWindowIcon.vue";
import selectRoleChecker from "@/router/selectRoleChecker";
import { formatDateTime } from "@/services/functions";
import Api from "@/services/api/ApiServiceFabrick";
import auditLog from "@/types/responses/auditLog";
import SelfAccount from "@/types/SelfAccount";
import { onMounted, ref } from "vue";
import i18n from "@/lang/i18n";
import {
  SELECTABLE_AUDITABLE_TYPE_ITEMS,
  SELECTABLE_EVENT_ITEMS,
  ID_LABELS,
  OPERATION_OFFICE_TYPE,
  DEPARTMENT_OFFICE_TYPE,
} from '@/services/consts';


export default /*@__PURE__*/_defineComponent({
  __name: 'ListRow',
  props: {
    auditLogs: {},
    isLoading: { type: Boolean },
    isSearchCompleted: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

const SELECTED_ROLE = selectRoleChecker.getCurrentRole()
const IS_OPERATION_OR_DEPARTMENT = SELECTED_ROLE && (SELECTED_ROLE.organization_type === OPERATION_OFFICE_TYPE || SELECTED_ROLE.organization_type === DEPARTMENT_OFFICE_TYPE)
const selfAccount = ref<SelfAccount | null>(null)

onMounted(async () => {
  if (IS_OPERATION_OR_DEPARTMENT) {
    await Api().getSelfAccount().then((data: SelfAccount) => {
      selfAccount.value = data
    })
  }
})

function displayType(auditLog: auditLog) {
  return SELECTABLE_AUDITABLE_TYPE_ITEMS.find(item => item.value === auditLog.auditable_type)?.name
}

function displayEventName(auditLog: auditLog) {
  return SELECTABLE_EVENT_ITEMS.find(item => item.value === auditLog.event)?.name
}

function eventNameColor(auditLog: auditLog) {
  switch (auditLog.event) {
    case 'created':
      return 'rgb(21, 130, 156)'
    case 'deleted':
      return 'danger'
    default:
      return ''
  }
}

function displayIdLabel(auditLog: auditLog) {
  const idLabel = ID_LABELS[auditLog.auditable_type as keyof typeof ID_LABELS] ?? i18n.global.t('pages.auditLog.list.id')
  const auditableId = auditLog.auditable_type == 'workload' ? auditLog.auditable.delivery_plan_id : auditLog.auditable_id
  return `${idLabel}: ${auditableId}`
}

function isAvailableOperationOffice(auditLog: auditLog) {
  if (!IS_OPERATION_OR_DEPARTMENT || auditLog.auditable_type !== 'operation_office') {
    return true
  }

  return selfAccount.value?.officeable_id == auditLog.auditable_id
}

function isDisplayOpenNewWindowIcon(auditLog: auditLog) {
  const isDeleted = auditLog.event === 'deleted';

  return !isDeleted && isAvailableOperationOffice(auditLog);
}

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!

  return (_openBlock(), _createElementBlock("tbody", null, [
    (props.auditLogs.length)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(props.auditLogs, (auditLog) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: auditLog.id
          }, [
            _createElementVNode("td", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, _toDisplayString(auditLog.id), 1)
            ]),
            _createElementVNode("td", _hoisted_3, _toDisplayString(displayType(auditLog)), 1),
            _createElementVNode("td", _hoisted_4, [
              _createVNode(_component_v_chip, {
                variant: "tonal",
                color: eventNameColor(auditLog)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(displayEventName(auditLog)), 1)
                ]),
                _: 2
              }, 1032, ["color"])
            ]),
            _createElementVNode("td", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(displayIdLabel(auditLog)), 1),
                _createElementVNode("div", _hoisted_8, [
                  (isDisplayOpenNewWindowIcon(auditLog))
                    ? (_openBlock(), _createBlock(OpenNewWindowIcon, {
                        key: 0,
                        auditLog: auditLog
                      }, null, 8, ["auditLog"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("td", _hoisted_9, _toDisplayString(auditLog.user.id), 1),
            _createElementVNode("td", _hoisted_10, _toDisplayString(auditLog.user.name), 1),
            _createElementVNode("td", _hoisted_11, _toDisplayString(_unref(formatDateTime)(new Date(auditLog.created_at))), 1),
            _createElementVNode("td", _hoisted_12, _toDisplayString(auditLog.ip_address), 1)
          ]))
        }), 128))
      : (!props.auditLogs?.length && !props.isLoading && props.isSearchCompleted)
        ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
            _createElementVNode("td", _hoisted_14, _toDisplayString(_unref(i18n).global.t('pages.common.list.noData')), 1)
          ]))
        : _createCommentVNode("", true)
  ]))
}
}

})